import { createContext, useContext, useState, useCallback } from 'react';
import type { ReactNode } from 'react';

interface FooterContextValue {
  showPlus: boolean;
  plusClickHandler?: () => void;
  setFooterPlusButton: (show: boolean, handler?: () => void) => void;
}

const FooterContext = createContext<FooterContextValue | undefined>(undefined);

interface FooterProviderProps {
  children: ReactNode;
}

export function FooterProvider({ children }: FooterProviderProps) {
  const [showPlus, setShowPlus] = useState(false);
  const [plusClickHandler, setPlusClickHandler] = useState<
    (() => void) | undefined
  >(undefined);

  const setFooterPlusButton = useCallback(
    (show: boolean, handler?: () => void) => {
      setShowPlus(show);
      setPlusClickHandler(handler ? () => handler : undefined);
    },
    []
  );

  const value: FooterContextValue = {
    showPlus,
    plusClickHandler,
    setFooterPlusButton,
  };

  return (
    <FooterContext.Provider value={value}>{children}</FooterContext.Provider>
  );
}

export function useFooterContext(): FooterContextValue {
  const context = useContext(FooterContext);

  if (context === undefined) {
    throw new Error('useFooterContext must be used within a FooterProvider');
  }

  return context;
}
